module.exports = __webpack_public_path__ + "src/assets/img/brand-02.jpg";